import t from './story04.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,
  region0Name: t.region0Name,
  region1Name: t.region1Name,

  prose: [
    // Run 1 — the open, no heading. Ends on the first Powers-Riggs pull quote.
    [{ text: t.s1P1 }, { text: t.s1P2 }, { text: t.s1P3 }, { text: t.s1P4 }],
    // Run 2 — first themed section, up to the gallium figure.
    [{ title: t.s2Title, text: t.s2P1 }, { text: t.s2P2 }, { text: t.s2P3 }],
    // Run 3 — continues after the figure: the export controls, 2022 to 2025. Ends
    // on the second figure, which sits immediately before the next heading.
    [
      { text: t.s3P1 },
      { text: t.s3P2 },
      { text: t.s3P3 },
      { text: t.s3P4 },
      { text: t.s3P5 },
    ],
    // Run 4 — second themed section, up to the second pull quote.
    [{ title: t.s4Title, text: t.s4P1 }, { text: t.s4P2 }, { text: t.s4P3 }],
    // Run 5 — the close. Its last two blocks are one paragraph in the doc, split
    // by a soft line break that markdown-lite has no token for.
    [
      { title: t.s5Title, text: t.s5P1 },
      { text: t.s5P2 },
      { text: t.s5P3 },
      { text: t.s5P4 },
      { text: t.s5P5 },
      { text: t.s5P6 },
      { text: t.s5P7 },
    ],
  ],

  // Only the inline figure is credited; the hero carries no pie de foto.
  captions: [[t.f1P1], [t.f2P1]],

  quotes: [
    { text: t.q1, attribution: t.q1Attr },
    { text: t.q2, attribution: t.q2Attr },
  ],
} as const
